import { render } from "./ClaimsView.vue?vue&type=template&id=d8dc5eec"
import script from "./ClaimsView.vue?vue&type=script&lang=js"
export * from "./ClaimsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__